import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import berita from '../views/Berita/berita.vue'
import isiBerita from '../views/Berita/isiBerita.vue'
import dataPegawai from '../views/profil/datapegawai.vue'
import programKegiatan from '../views/profil/programKegiatan.vue'
import strukturOrganisasi from '../views/profil/strukturOrganisasi.vue'
import tentangKami from '../views/profil/tentangKami.vue'
import tugasPokok from '../views/profil/tugasPokok.vue'
import visiMisi from '../views/profil/visiMisi.vue'
import bidangTataLingkungan from '../views/unitKerja/bidangTataLingkungan.vue'
import bidangPengelolaanSampah from '../views/unitKerja/bidangPengelolaanSampah.vue'
import bidangPengendalianPencemaran from '../views/unitKerja/bidangPengendalianPencemaran.vue'
import bidangPenataanLH from '../views/unitKerja/bidangPenataanLH.vue'
import sekretariat from '../views/unitKerja/sekretariat.vue'
import formulir from '../views/dokumen/formulir.vue'
import sop from '../views/dokumen/sop.vue'
import foto from '../views/galeri/foto.vue'
import video from '../views/galeri/video.vue'
import layanan from '../views/layanan.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: isiBerita
  },
  {
    path: '/dataPegawai',
    name: 'dataPegawai',
    component: dataPegawai
  },
  {
    path: '/programKegiatan',
    name: 'programKegiatan',
    component: programKegiatan
  },
  {
    path: '/strukturOrganisasi',
    name: 'strukturOrganisasi',
    component: strukturOrganisasi
  },
  {
    path: '/tentangKami',
    name: 'tentangKami',
    component: tentangKami
  },
  {
    path: '/tugasPokok',
    name: 'tugasPokok',
    component: tugasPokok
  },
  {
    path: '/visiMisi',
    name: 'visiMisi',
    component: visiMisi
  },
  {
    path: '/bidangTataLingkungan',
    name: 'bidangTataLingkungan',
    component: bidangTataLingkungan
  },
  {
    path: '/bidangPengelolaanSampah',
    name: 'bidangPengelolaanSampah',
    component: bidangPengelolaanSampah
  },
  {
    path: '/bidangPengendalianPencemaran',
    name: 'bidangPengendalianPencemaran',
    component: bidangPengendalianPencemaran
  },
  {
    path: '/bidangPenataanLH',
    name: 'bidangPenataanLH',
    component: bidangPenataanLH
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: sekretariat
  },
  {
    path: '/formulir',
    name: 'formulir',
    component: formulir
  },
  {
    path: '/sop',
    name: 'sop',
    component: sop
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
  {
    path: '/layanan',
    name: 'layanan',
    component: layanan
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
